const ReportStatus = {
  NEW: "new",
  INWORK: "in work",
  COMPLETED: "completed",
  FAILED: "failed",
};

Object.seal(ReportStatus);
export default ReportStatus;
